
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getMakes = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/Makes`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getModels = (make, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/Models/` + make, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const searchVehicles = (searchRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Vehicles/Search`, searchRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getDisclosures = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/Disclosures/` + vehicleId, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getBuildData = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/BuildData/` + vehicleId, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getPagedOwnedVehicles = (pagingRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Vehicles/OwnedVehicles`, pagingRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addOwnershipRequest = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/AddOwnershipRequest/` + vehicleId, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addShippingRequest = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Vehicles/AddShippingRequest/` + vehicleId, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const VehiclesService =
{
	getMakes,
	getModels,
	searchVehicles,
	getDisclosures,
	getBuildData,
	getPagedOwnedVehicles,
	addOwnershipRequest,
	addShippingRequest
}

export default VehiclesService
